module.exports = __webpack_public_path__ + "img/nor_cs_moun1.7bccf508.png";